import React, { useEffect } from 'react';
import * as styles from './bownow.module.scss';

const ModalContent: React.FC<{sid: String}> = ({sid}) => {
  const src = `https://contents.bownow.jp/forms/${sid}/trace.js`;

  useEffect(() => {
    const bownow_form = document.createElement('script');
    bownow_form.charset = 'utf-8';
    bownow_form.src = src;
    document.getElementsByTagName('head')[0].appendChild(bownow_form);
    return () => {
      bownow_form.remove();
    };
  }, []);

  return (
    <div className={styles.oBownow}>
      <script id={`_bownow_cs_${sid}`}></script>
    </div>
  );
};

export default ModalContent;
